import { useEffect, useRef, useState } from "react";
import { QRCodeCanvas } from "qrcode.react";
import { DownloadSimple, ShoppingCart } from "@phosphor-icons/react";
import { guestUrl } from "@/lib/api";
import { PORTRAIT, drawPortrait, loadImg } from "@/lib/portrait";
import { save } from "@/pages/host/editor/PrintKit";

export function PortraitPreview({ properties, onAttach }) {
  const [pid, setPid] = useState(properties[0]?.property_id || "");
  const p = properties.find((x) => x.property_id === pid) || properties[0];
  const canvas = useRef();
  const qr = useRef();

  useEffect(() => {
    if (!p) return;
    let live = true;
    const h = p.data.host;
    Promise.all([document.fonts.ready, loadImg(h.logo || h.photo)]).then(([, logo]) => {
      if (live) drawPortrait(canvas.current, { name: p.data.name, hostName: h.name, qr: qr.current?.querySelector("canvas"), logo });
    });
    return () => { live = false; };
  }, [p]);

  if (!properties.length) return null;
  return (
    <section className="rounded-2xl border border-border bg-white p-6" data-testid="portrait-preview">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div><h3 className="font-display text-lg">NFC card preview · portrait</h3><p className="text-sm text-muted-foreground">QR code, property name, your logo and hostkey.online.</p></div>
        <select value={p?.property_id || ""} onChange={(e) => setPid(e.target.value)} data-testid="portrait-property-select" className="h-9 rounded-lg border border-border bg-white px-2 text-sm">
          {properties.map((x) => <option key={x.property_id} value={x.property_id}>{x.data.name}</option>)}
        </select>
      </div>
      {p && <div className="hidden" ref={qr}><QRCodeCanvas value={guestUrl(p.slug)} size={420} marginSize={1} /></div>}
      <div className="mt-5 flex flex-wrap items-end gap-6">
        <canvas ref={canvas} width={PORTRAIT[0]} height={PORTRAIT[1]} className="w-[230px] rounded-[16px] shadow-[0_24px_48px_-24px_rgba(14,23,41,.6)]" data-testid="portrait-canvas" />
        <div className="space-y-2">
          <p className="text-xs text-muted-foreground">54 × 85.6 mm · portrait</p>
          <p className="max-w-xs text-xs text-muted-foreground">Add your logo in the editor's Host tab. If there's no logo, your profile photo or first initial is used.</p>
          <button type="button" onClick={() => save(canvas.current, `${p.data.name}-portrait-card.png`)} data-testid="portrait-download-button" className="inline-flex h-9 items-center gap-1.5 rounded-lg border border-border px-3 text-sm font-semibold"><DownloadSimple /> Download PNG</button>
          <button type="button" onClick={() => onAttach({ kind: "portrait", property_id: p.property_id, kh_id: null, property_name: p.data.name, label: "Portrait card" })} data-testid="portrait-attach-button" className="flex h-9 items-center gap-1.5 rounded-lg bg-[#D96C4A] px-3 text-sm font-semibold text-white hover:bg-[#C25D3E]"><ShoppingCart /> Add this card to my order</button>
        </div>
      </div>
    </section>
  );
}
